<template>
    <div class="pa-5" v-if="activeProduct">
        <strong>{{ "Single package" | t }}:</strong>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Neto weight" | t }} (g)</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.neto_weight"
                    @input="updateField($event, 'neto_weight')"
                    type="number"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Empty package weight" | t }} (g)</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.package_weight"
                    @input="updateField($event, 'package_weight')"
                    type="number"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Bruto weight" | t }} (g)</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.bruto_weight"
                    @input="updateField($event, 'bruto_weight')"
                    type="number"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Outer carton height" | t }} (mm)</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.outer_carton_height"
                    @input="updateField($event, 'outer_carton_height')"
                    type="number"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Outer carton depth" | t }} (mm)</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.outer_carton_depth"
                    @input="updateField($event, 'outer_carton_depth')"
                    type="number"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Outer carton width" | t }} (mm)</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.outer_carton_width"
                    @input="updateField($event, 'outer_carton_width')"
                    type="number"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Package material" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.package_material"
                    @input="updateField($event, 'package_material')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>

        <v-divider class="mb-3 mt-3" />

        <strong>{{ "Group package" | t }}:</strong>

        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Box type" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.group_package_box_type"
                    @input="updateField($event, 'group_package_box_type')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Bags in the box" | t }} ({{ "pcs" | t }})</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.bags_in_box"
                    @input="updateField($event, 'bags_in_box')"
                    type="number"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Box height" | t }} (mm)</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.group_package_outer_carton_height"
                    @input="updateField($event, 'group_package_outer_carton_height')"
                    type="number"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Box depth" | t }} (mm)</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.group_package_outer_carton_depth"
                    @input="updateField($event, 'group_package_outer_carton_depth')"
                    type="number"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Box width" | t }} (mm)</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.group_package_outer_carton_width"
                    @input="updateField($event, 'group_package_outer_carton_width')"
                    type="number"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Empty Box weight" | t }} (g)</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.group_package_empty_box_weight"
                    @input="updateField($event, 'group_package_empty_box_weight')"
                    type="number"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Group package bruto weight" | t }} (g)</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.group_package_bruto_weight"
                    @input="updateField($event, 'group_package_bruto_weight')"
                    type="number"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Box code" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.group_package_box_code"
                    @input="updateField($event, 'group_package_box_code')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-divider class="mb-3 mt-3" />

        <strong>{{ "Transparent wrap package" | t }}:</strong>

        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Transparent wrap dimensions" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.transparent_wrap_dimensions"
                    @input="updateField($event, 'transparent_wrap_dimensions')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Transparent wrap width" | t }} (mm)</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.transparent_wrap_width"
                    @input="updateField($event, 'transparent_wrap_width')"
                    type="number"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Transparent wrap length" | t }} (mm)</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.transparent_wrap_length"
                    @input="updateField($event, 'transparent_wrap_length')"
                    type="number"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Transparent wrap comments" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.transparent_wrap_comment"
                    @input="updateField($event, 'transparent_wrap_comment')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Transparent wrap code" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.transparent_wrap_code"
                    @input="updateField($event, 'transparent_wrap_code')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-divider class="mb-0 mt-3" />
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import Store from "../../../store";

export default {
    name: "package-edit-tab",
    data() {
        return {
            statusItems: ["active", "pending", "inactive"]
        };
    },
    computed: {
        ...mapState("ProductStore", ["activeProduct", "productCategories"])
    },
    methods: {
        ...mapMutations("ProductStore", ["changeClassificatorValue"]),
        updateField(value, field) {
            Store.commit("ProductStore/updateActiveProductProperty", { prop: field, value: value });
        },
        updateJsonField(value, field) {
            Store.commit("ProductStore/updateActiveProductJsonField", { prop: field, value: value });
        },
        generatePalletBoxCount(force = false) {
            let product = this.activeProduct;
            if (force) {
                const boxCount = product.boxes_in_base_layer * product.layers_on_pallet;
                Store.commit("ProductStore/updateActiveProductProperty", {
                    prop: "boxes_on_pallet",
                    value: boxCount
                });
                return;
            }

            if (
                product.boxes_in_base_layer &&
                product.boxes_in_base_layer > 0 &&
                product.layers_on_pallet &&
                product.layers_on_pallet > 0 &&
                !product.boxes_on_pallet
            ) {
                const boxCount = product.boxes_in_base_layer * product.layers_on_pallet;
                Store.commit("ProductStore/updateActiveProductProperty", {
                    prop: "boxes_on_pallet",
                    value: boxCount
                });
            }
        }
    }
};
</script>

<style scoped>
.row-title {
    color: #888;
}
::v-deep .v-input__slot {
    min-height: 9px !important;
}
::v-deep .v-input__icon {
    padding-bottom: 8px;
}
</style>
